import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Settlement/rightAngle.png'


const _withScopeId = n => (_pushScopeId("data-v-775e9e70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Settlement" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "计划说明", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "rightAngle",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "headContent" }
const _hoisted_7 = { class: "classTitle" }
const _hoisted_8 = { class: "contentBox" }
const _hoisted_9 = {
  key: 0,
  class: "paymentTime"
}
const _hoisted_10 = {
  key: 0,
  class: "remaining"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 剩余支付时间：", -1))
const _hoisted_12 = { class: "countTime" }
const _hoisted_13 = { class: "block" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_15 = { class: "block" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_17 = { class: "block" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "报班班级", -1))
const _hoisted_21 = { class: "labelText" }
const _hoisted_22 = { class: "label" }
const _hoisted_23 = { class: "labelText" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hasSelect" }, "已选费用", -1))
const _hoisted_25 = { class: "cardContent" }
const _hoisted_26 = { class: "footBtm" }
const _hoisted_27 = { class: "foottext" }
const _hoisted_28 = { class: "yingfu" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("应付金额 ")
const _hoisted_30 = { class: "symbol" }
const _hoisted_31 = { class: "money" }
const _hoisted_32 = { class: "symbol" }
const _hoisted_33 = { class: "hasSelectTip" }
const _hoisted_34 = { class: "flexBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_CardItem = _resolveComponent("CardItem")!
  const _component_Pay = _resolveComponent("Pay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.fee.info['remark'])
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "plan",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPlan && _ctx.showPlan(...args)))
          }, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.fee.info.feePlanName), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.cancel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("h5", null, "订单" + _toDisplayString(_ctx.fee.info.payStatus==1?'待支付':'已支付'), 1),
              (_ctx.fee.info.payStatus==1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_CountDown, {
                      time: _ctx.fee.info.cancelOrderCountdown*1000,
                      format: "HH:mm:ss"
                    }, {
                      default: _withCtx((timeData) => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getNumberTime(timeData).hours), 1),
                          _hoisted_14,
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getNumberTime(timeData).minutes), 1),
                          _hoisted_16,
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.getNumberTime(timeData).seconds), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["time"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.fee.info.className), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fee.info.feePlanUserFormVoList, (item, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(item.fieldName), 1),
              _createElementVNode("div", _hoisted_23, _toDisplayString(item.fieldId == 7?_ctx.area:item.fieldValue1), 1)
            ])), [
              [_vShow, item.fieldShow == 1]
            ])
          }), 128))
        ])
      ]),
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_CardItem, {
          list: _ctx.fee.info.itemVoList,
          feeType: _ctx.fee.info.feeType
        }, null, 8, ["list", "feeType"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", {
            class: _normalizeClass(["submitMoney", {'flexEnd':!_ctx.cancel}])
          }, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _withDirectives(_createElementVNode("span", _hoisted_30, "¥", 512), [
                [_vShow, !_ctx.cancel]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("span", _hoisted_32, "¥ ", 512), [
                [_vShow, _ctx.cancel]
              ]),
              _createTextVNode(_toDisplayString(_ctx.computePrice / 100), 1)
            ])
          ], 2),
          _withDirectives(_createElementVNode("div", _hoisted_33, "请认真核对信息即费用", 512), [
            [_vShow, !_ctx.cancel]
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _withDirectives(_createElementVNode("div", {
            class: "submit cancelSubmit",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelPay && _ctx.cancelPay(...args)))
          }, "取消支付", 512), [
            [_vShow, _ctx.cancel && _ctx.fee.info.payStatus==1]
          ]),
          _createElementVNode("div", {
            class: "submit toSubmit",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showPay && _ctx.showPay(...args)))
          }, "去支付")
        ])
      ])
    ]),
    _createVNode(_component_Pay, {
      onPayStart: _ctx.payStart,
      orderNumber: _ctx.fee.orderInfo.orderNumber,
      params: _ctx.fee.params,
      returnUrl: _ctx.fee.returnUrl
    }, null, 8, ["onPayStart", "orderNumber", "params", "returnUrl"])
  ], 64))
}